<template>
  <CDropdown :up="up" :theme :icon="getIcon?.(modelValue)" :title="title ?? getLabel?.(modelValue)" :placeholder class="c-options-dropdown" :fontWeight="fontWeight">
    <template v-if="options.length > 0">
      <CButton v-for="(option, index) in options" :key="index" :theme="optionTheme" @click="model = option" :fontWeight="fontWeight">
        <CIcon v-if="getIcon" :name="getIcon(option)" class="c-options-dropdown-icon"/>
        {{ getLabel?.(option) }}
      </CButton>
    </template>
    <div v-else class="c-options-dropdown__empty-message">
      <p>{{ emptyOptionsMessage }}</p>
    </div>
  </CDropdown>
</template>

<script setup lang="ts">
  import CIcon from '@/shared/components/CIcon.vue';
  import CButton, { Theme } from '@/shared/components/buttons/CButton.vue';
  import CDropdown from '@/shared/components/dropdown/CDropdown.vue';

  type Option = any;

  defineProps<{
    modelValue: Option,
    options: Array<Option>,
    getLabel?: (option: Option) => string,
    title?: string,
    getIcon?: (option: Option) => string,
    theme?: Theme,
    optionTheme?: Theme,
    up?: boolean,
    fontWeight?: 'normal' | 'bold',
    placeholder?: string,
    emptyOptionsMessage?: string,
  }>();

  const model = defineModel<Option>();
</script>
